export default "__VITE_ASSET__a7489206__"